import { composeReducers } from 'common/util';
import lodash from 'lodash';

import {
    LOAD_STUDY_ROLES,
    ADD_STUDY_ROLE,
    REMOVE_ROLE,
    UPDATE_ROLE,
} from 'complionAdmin/actions/studyRoles';

export function loadStudyRoles(state, action) {
    if (!action || action.type !== LOAD_STUDY_ROLES) {
        return state;
    }
    return {
        ...state,
        doaRoles: action.payload,
    };
}

export function addStudyRole(state, action) {
    if (!action || action.type !== ADD_STUDY_ROLE) {
        return state;
    }

    if (lodash.isNil(action.payload) || lodash.isEmpty(action.payload)) {
        return state;
    }

    const existingRoles = state.doaRoles || [];

    existingRoles.push(action.payload);

    const nonSystemRoles = lodash
        .filter(existingRoles, role => role.isSystem === false)
        .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
    const systemRoles = lodash
        .filter(existingRoles, role => role.isSystem === true)
        .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
    const newStudyRoles = lodash.concat(systemRoles, nonSystemRoles);

    return {
        ...state,
        doaRoles: lodash.cloneDeep(newStudyRoles),
    };
}

export function removeRole(state, action){
    if(!action || action.type !== REMOVE_ROLE){
        return state;
    }

    const updatedRoles = state.doaRoles.filter(role => role.id !== action.payload.id);
    
    if (lodash.isNil(updatedRoles)) {
        return state;
    }

    return{
        ...state,
        doaRoles: updatedRoles,
    };
}

export function updateRole(state, action){
    if(!action || action.type !== UPDATE_ROLE){
        return state;
    }

    const updatedRoles = state.doaRoles.map((role) => {
        if (role.id === action.payload.id) {
            role.active = action.payload.active;
        }
        return role;
    });
    
    return {
        ...state,
        doaRoles: updatedRoles,
    };
}

export default composeReducers(
    loadStudyRoles,
    addStudyRole,
    removeRole,
    updateRole,
);
